export const electron = typeof window != 'undefined' ? window.electron : undefined
